module.exports = __webpack_public_path__ + "media/assets/images/synchronize_start_navy-6a188c0ec713dc6a7657acab34bcfc0b.png";